import { clientApi as dataConnectWebClientApi } from '@openclassrooms/data-connect-web/configuration';
import OCAISDK from '@openclassrooms/js-ai-sdk';
import type { APILanguage } from '@openclassrooms/sdk';

import { AI_PROXY_API_ROUTE } from './constants';

export function initAiSdk({ language }: { language: APILanguage }) {
  dataConnectWebClientApi.setAIClientFactory(() => {
    const client = new OCAISDK({
      accessToken: 'proxy',
      rootUrl: AI_PROXY_API_ROUTE,
      language,
    });

    client.addRequestInterceptor(async (requestData) => ({
      ...requestData,
      headers: { ...requestData.headers, Authorization: 'true' },
    }));

    return client;
  });
}
